import FormInput from "./FormInput";

/** 
 type parameter can be "owner" or "authorized"
 */
export default function Actor ({ type, readonly=false, register, control, errors, setValue }) {
  let fieldPrefix = '';
  if(type === 'authorized') fieldPrefix = 'auth_';

  return (
    <>
      <label
        className="form-item__label form-item"
        style={{ fontSize: "1rem" }}
      >
        { type === 'owner' && 'Plate Owner Information'}
        { type === 'authorized' && 'Authorized Party Information'}
      </label>
      <div className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper">
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id={`${fieldPrefix}firstName`}
                type="text"
                label="First Name"
                register={register(`${fieldPrefix}firstName`)}
                error={errors[`${fieldPrefix}firstName`]}
                readonly={readonly}
              />
            </div>
          </div>
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id={`${fieldPrefix}lastName`}
                type="text"
                label="Last Name (or company)"
                register={register(`${fieldPrefix}lastName`, {
                  required: "Last name or company name is required",
                })}
                error={errors[`${fieldPrefix}lastName`]}
                required={!readonly}
                readonly={readonly}
              />
            </div>
          </div>
        </div>
        <div className="webform-flexbox webform-flexbox--flex-end js-webform-flexbox js-form-wrapper form-wrapper">
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id={`${fieldPrefix}email`}
                type="text"
                label="Email"
                description="Ensure your email address is correct, as it will be our main method of communication."
                descriptionLocation="before"
                register={register(`${fieldPrefix}email`, { 
                  required: "Email is required", 
                  pattern: { value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i, message: "Invalid email" }
                })}
                maxLength={100}
                error={errors[`${fieldPrefix}email`]}
                required
                preventPaste
              />
            </div>
          </div>
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id={`${fieldPrefix}emailConfirm`}
                type="text"
                label="Confirm Email"
                register={register(`${fieldPrefix}emailConfirm`, {
                  required: "Email confirmation is required",
                  pattern: { value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i, message: "Invalid email" },
                  validate: (value, formValues) => value === formValues[`${fieldPrefix}email`] || 'Emails do not match'
                })}
                maxLength={100}
                error={errors[`${fieldPrefix}emailConfirm`]}
                required
                preventPaste
              />
            </div>
          </div>
        </div>
        <div className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper">
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id={`${fieldPrefix}phone`}
                type="text"
                label="Phone Number"
                register={register(`${fieldPrefix}phone`, {
                  required: "Phone number is required", 
                  pattern: { value: /^\d{3}-\d{3}-\d{4}$/gm, message: "Invalid phone number" }
                })}
                error={errors[`${fieldPrefix}phone`]}
                mask="999-999-9999"
                required
                control={control}
                setValue={setValue}
              />
            </div>
          </div>
        </div>
        <div className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper">
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id={`${fieldPrefix}streetAddress`}
                type="text"
                label="Street Address"
                register={register(`${fieldPrefix}streetAddress`, {required: "Street address is required"})}
                error={errors[`${fieldPrefix}streetAddress`]}
                required={!readonly}
                readonly={readonly}
              />
            </div>
          </div>
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id={`${fieldPrefix}municipality`}
                type="text"
                label="Town / City"
                register={register(`${fieldPrefix}municipality`, {required: "Town / City is required"})}
                error={errors[`${fieldPrefix}municipality`]}
                required={!readonly}
                readonly={readonly}
              />
            </div>
          </div>
        </div>
        <div className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper">
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <FormInput
                id={`${fieldPrefix}province`}
                type="text"
                label="Province"
                register={register(`${fieldPrefix}province`, {required: "Province is required"})}
                error={errors[`${fieldPrefix}province`]}
                required={!readonly}
                readonly={readonly}
              />
            </div>
          </div>
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
            { control && <FormInput
                id={`${fieldPrefix}postalCode`}
                type="text"
                label="Postal Code"
                register={register(`${fieldPrefix}postalCode`, {required: "Postal Code is required"})}
                control={control}
                error={errors[`${fieldPrefix}postalCode`]}
                required={!readonly}
                readonly={readonly}
                mask={!readonly ? "a9a 9a9" : null}
                setValue={setValue}
              /> }
            </div>
          </div>
        </div>
    </>
  );
}
